(() => {
  const initialize = () => {
    const root = document.querySelector('[data-cha-lz-pattern-lab]');
    const data = window.ChaLzSloperNecData;
    const files = window.ChaLzSloperNecFiles;
    if (!root || !data || !files || root.dataset.chaLzReady === 'true') return;
    root.dataset.chaLzReady = 'true';
    let whip = 'SS17';
    let band = '20';

    const setText = (selector, value) => {
      const element = root.querySelector(selector);
      if (element) element.textContent = value;
    };
    const signed = (value) => `${value > 0 ? '+' : ''}${value}%`;

    let renderSequence = 0;
    const render = async () => {
      const sequence = ++renderSequence;
      const record = data.cases?.[whip]?.[band];
      const urls = files?.[whip]?.[band];
      if (!record || !urls) return;
      root.querySelectorAll('[data-cha-lz-whip]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.chaLzWhip === whip));
      });
      root.querySelectorAll('[data-cha-lz-band]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.chaLzBand === band));
      });
      root.querySelectorAll('[data-cha-lz-nvis-whip]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.chaLzNvisWhip === whip && button.dataset.chaLzNvisBand === band));
      });
      ['elevation', 'azimuth'].forEach((view) => {
        const image = root.querySelector(`[data-cha-lz-image="${view}"]`);
        const link = root.querySelector(`[data-cha-lz-link="${view}"]`);
        const alt = `MPAS Lite with ${whip} and LZ Sloper ${band} meter ${view} pattern`;
        if (image) {
          image.src = urls[view];
          image.alt = alt;
        }
        if (link) {
          link.href = urls[view];
          link.setAttribute('aria-label', `Open HD ${alt}`);
        }
      });
      setText('[data-cha-lz-selected-system]', `MPAS Lite · ${whip} · LZ Sloper · ${band} m`);
      setText('[data-cha-lz-peak]', record.peakElevationDeg >= 89
        ? `${record.peakElevationDeg}° elevation · overhead/high-angle maximum`
        : `${record.peakElevationDeg}° elevation · ${record.peakAzimuthDeg}° model-axis azimuth`);
      setText('[data-cha-lz-change]', `${signed(record.strongestDirectionChangePercent)} in the strongest direction · ${signed(record.integratedChangePercent)} modeled upper-hemisphere total`);
      setText('[data-cha-lz-reading]', record.reading);
      setText('[data-cha-lz-reason]', record.reason);
      const figure = root.querySelector('[data-cha-lz-3d]');
      const canvas = root.querySelector('[data-cha-lz-3d-canvas]');
      const status = root.querySelector('[data-cha-lz-3d-status]');
      const openButton = root.querySelector('[data-cha-lz-3d-open]');
      if (figure && canvas && status && openButton) {
        figure.dataset.nec3dModel = record.modelId;
        openButton.dataset.nec3dModel = record.modelId;
        openButton.disabled = true;
        status.textContent = 'Loading the exact 3D pattern…';
        try {
          if (!window.CKB_NEC3D?.mountInline) await new Promise((resolve) => document.addEventListener('ckb:nec3d-ready', resolve, { once:true }));
          const mounted = await window.CKB_NEC3D.mountInline(canvas, record.modelId);
          if (sequence !== renderSequence || mounted.modelId !== record.modelId) return;
          status.textContent = 'Drag to rotate · scroll or pinch to zoom';
          openButton.disabled = false;
        } catch (error) {
          if (sequence !== renderSequence) return;
          status.textContent = 'The exact governed 3D source is unavailable.';
          console.error(error);
        }
      }
    };

    root.addEventListener('click', (event) => {
      const whipButton = event.target.closest('[data-cha-lz-whip]');
      const bandButton = event.target.closest('[data-cha-lz-band]');
      const nvisButton = event.target.closest('[data-cha-lz-nvis-whip]');
      if (whipButton) whip = whipButton.dataset.chaLzWhip;
      if (bandButton) band = bandButton.dataset.chaLzBand;
      if (nvisButton) {
        whip = nvisButton.dataset.chaLzNvisWhip;
        band = nvisButton.dataset.chaLzNvisBand;
      }
      if (whipButton || bandButton || nvisButton) render();
    });
    render();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
